import { Component, OnInit, Input } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { QuoteTrackingService } from '../../../quote-tracking.service'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-quote-reject-dialog',
  templateUrl: './quote-reject-dialog.component.html',
  styleUrls: ['./quote-reject-dialog.component.scss'],
})
export class QuoteRejectDialogComponent implements OnInit {
  @Input()
  quoteId: any
  reasonForRejection = ''
  comments: string
  isSumbitted = false
  isComment = false
  reasonsForRejection$: Observable<any>
  reasonsForRejection
  constructor(
    private launchDialogService: LaunchDialogService,
    private quoteTrackingService: QuoteTrackingService
  ) {}
  // reasonsForRejection = [{
  //   name: "Alternate Solution Selected (Repair / Replace)",
  //   code: "Alternate Solution Selected (Repair / Replace)"
  // },
  // {
  //   name: "Cancelled or Postponed ",
  //   code: "Cancelled or Postponed "
  // },
  // {
  //   name: "Duplicate Quotation",
  //   code: "Duplicate Quotation"
  // },
  // {
  //   name: "Lost - Quote Response Time",
  //   code: "Lost - Quote Response Time"
  // },
  // {
  //   name: "Lost - Lead Time / Delivery",
  //   code: "Lost - Lead Time / Delivery"
  // },
  // {
  //   name: "Lost - Price % vs. Competition",
  //   code: "Lost - Price % vs. Competition"
  // },
  // {
  //   name: "Lost – Technical",
  //   code: "Lost – Technical"
  // }];
  ngOnInit(): void {
    this.reasonsForRejection$ = this.quoteTrackingService.reasonForReject()
    this.reasonsForRejection$.subscribe((res) => {
      this.reasonsForRejection = res
    })
    this.launchDialogService.data$.subscribe((data) => {
      this.quoteId = data.quoteId
    })
  }

  closeModal(reasonForRejection, comments?): void {
    this.isSumbitted = true
    if (
      reasonForRejection !== '' &&
      reasonForRejection !== 'Select' &&
      comments !== '' &&
      comments !== undefined
    ) {
      let obj = {
        reasonForRejection: reasonForRejection,
        comments: comments,
      }
      const dialogResponse: DialogResponse = {
        type: VS_LAUNCH_CALLER.REJECT_QUOTE,
        reason: 'rejection',
        data: obj,
      }
      this.launchDialogService.closeDialog(dialogResponse)
    }
    if (comments == '' || comments == undefined) {
      this.isComment = true
    }
  }
}
